// Callback.jsx
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";

const Callback = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.activeNavigator === "signinRedirect") {
      auth.signinRedirectCallback().then(() => {
        const token = auth.user?.id_token;
        if (token) {
          localStorage.setItem("token", token);
          navigate("/dashboard");
        }
      });
    }
  }, [auth, navigate]);

  return <div>Loading...</div>;
};

export default Callback;
